import { classnames } from '@aibees/shared/utils';
import { Button, Stack } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { DialogFooterProps as Props } from './types';

export const DialogFooter = memo(
  ({ className, closeModal, onContactSupport }: Props) => {
    const handleClose = () => {
      closeModal?.();
    };

    const handleContactSupport = () => {
      onContactSupport?.();
    };

    return (
      <Styled.Wrapper
        className={classnames('DialogFooter', className)}
        sx={SX.root}
      >
        <Stack direction="row" justifyContent="space-between" width="100%">
          <Button
            variant="outlined"
            color="default"
            size="small"
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleContactSupport}
          >
            Contact Support
          </Button>
        </Stack>
      </Styled.Wrapper>
    );
  }
);

DialogFooter.displayName = 'DialogFooter';
